JSON.safeStringify = (obj, indent = 2) => {
  const cache = new WeakSet();
  return JSON.stringify(obj, (key, value) => {
    return typeof value === 'object' && value != null ? cache.has(value) ? undefined : cache.add(value) && value : value;
  }, indent);
};

export {};
